import cn from "clsx";
import React, { HTMLAttributes } from "react";
import { Text } from "../../text/Text";
import styles from "../Table.module.scss";

export type TableProps = React.PropsWithChildren<{}> &
    HTMLAttributes<HTMLTableRowElement>;

export const TableHeader: React.FC<TableProps> = ({
    children,
    className = "",
    ...rowProps
}) => {
    const elements = React.Children.toArray(children);
    return (
        <tr
            className={cn(styles.row, styles["row--header"], className)}
            {...rowProps}
        >
            {elements.map((child, index) => {
                const headerItemProps = React.isValidElement(child)
                    ? child.props
                    : {};
                const { children: headerChildren } = headerItemProps;
                return (
                    <th
                        className={styles.cell}
                        key={index}
                        scope={"col"}
                        data-column={`${index + 1}`}
                    >
                        <Text.Body variant={"2"}>{headerChildren}</Text.Body>
                    </th>
                );
            })}
        </tr>
    );
};
